import { User, JobRole, JobRoleTitle } from "../types";

/**
 * Check if a user can archive/unarchive a job role
 * Only Admin and Director roles can archive job roles
 */
export const canUserArchiveJobRole = (
  currentUser: User | null
): boolean => {
  if (!currentUser) return false;
  
  // Only Admin and Director can archive job roles
  return currentUser.userRole === 'Admin' || currentUser.userRole === 'Director';
};

/**
 * Check if a user can edit any job role (full access)
 * Only Admin and Director roles can edit any job role
 */
export const canEditJobRole = (
  currentUser: User | null
): boolean => {
  if (!currentUser) return false;
  
  // Only Admin and Director can edit any job role
  return currentUser.userRole === 'Admin' || currentUser.userRole === 'Director';
};

/**
 * Check if a user can edit job roles for their team members
 * Manager, Director, and Admin roles can edit team job roles
 */
export const canEditMyTeamJobRoles = (
  currentUser: User | null
): boolean => {
  if (!currentUser) return false;
  
  // Manager, Director and Admin can edit team job roles
  return ['Director', 'Admin'].includes(currentUser.userRole);
};

/**
 * Check if a job role is currently assigned to any users
 * Returns an array of users who have this job role
 */
export const getUsersWithJobRole = (
  allUsers: User[],
  jobRoleTitle: JobRoleTitle
): User[] => {
  return allUsers.filter(user => user.jobRole === jobRoleTitle);
};

/**
 * Filter job roles based on archived status
 */
export const filterJobRolesByArchivedStatus = (
  jobRoles: JobRole[],
  showArchived: boolean
): JobRole[] => {
  return jobRoles.filter(role => 
    showArchived ? role.archived : !role.archived
  );
}; 